module.exports = __webpack_public_path__ + "images/photo-editing-1-d35b9e4304b570fd09a584ae13cd8802.jpg";